import { useContext } from 'react'
import { BusinessComponentContext } from '../provider/BusinessProvider'

export function useBusinessContext() {
  return useContext(BusinessComponentContext)
}
